<template>
  <div class="section-report achieve">
    <Wrapper title="我的业绩">
      <template #header>
        <el-row>
          <el-col
            :sm="24"
            :md="12"
            :span="12"
          >
            <CheckTab
              :option="tabs"
              :active.sync="actTab"
              @change="onExTab"
            />
          </el-col>
          <el-col
            :sm="24"
            :md="12"
            :span="12"
            style="text-align: right;"
          >
            <DatePicker v-on:pick="pickDate" />
          </el-col>
        </el-row>
      </template>
      <template #content>
        <div class="box">
          <div class="chart">
            <div
              ref="chartblock"
              style="height: 500px"
            />
          </div>
          <div class="table">
            <el-table
              :data="ranklist"
              style="width: 100%"
              :cell-class-name="setTableCellClass"
              header-row-class-name="table-header"
            >
              <el-table-column label="排名">
                <template slot-scope="scope">
                  <span
                    class="table-index"
                    :style="makeTableRankStyles(scope.$index)"
                  >
                    {{ scope.$index + 1 }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="product_name"
                label="合作产品"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.product_name || '--' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="company"
                label="公司名称"
              >
                <template slot-scope="scope">
                  <a
                    style="text-decoration: none; cursor: pointer; color: #2F9EFF;"
                    @click="toDetail(scope.row.customer_id)"
                  >
                    {{ scope.row.company || '--' }}
                  </a>
                </template>
              </el-table-column>
              <el-table-column
                prop="total"
                label="消耗"
              >
                <template slot-scope="scope">
                  <span>¥{{ scope.row.total || '--' }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="涨幅"> </el-table-column> -->
            </el-table>
          </div>
        </div>
      </template>
    </Wrapper>
  </div>
</template>

<script>
import accounting from 'accounting';
import echarts from 'echarts';
import $util from '@/common/js/util';
import { baseLineOption, baseBarOption } from '../../echartConfig';
import roma from '../../echartConfig/roma.json';
import Request from '@/core/QuRequest';
import rank1 from '@/assets/image/rank/rank_1.png';
import rank2 from '@/assets/image/rank/rank_2.png';
import rank3 from '@/assets/image/rank/rank_3.png';
import Wrapper from '../../components/Wrapper';
import CheckTab from '../../components/CheckTab';
import DatePicker from '../../components/DatePicker';

const req = new Request();

const Tabs = {
  income: {
    id: 'income',
    text: '业绩收入',
    t: '业绩汇总',
    tp: { ...baseLineOption },
    type: 'line',
    xAxisf: '¥{value}',
    data: [],
  },
  actCustomer: {
    id: 'actCustomer',
    text: '活跃客户数',
    t: '客户数汇总',
    tp: { ...baseBarOption },
    type: 'bar',
    xAxisf: '{value} 个',
    data: [],
  },
  arpu: {
    id: 'arpu',
    text: 'ARPU',
    t: '',
    tp: { ...baseLineOption },
    type: 'line',
    xAxisf: '¥{value}',
    data: [],
  },
};

export default {
  name: 'SectionAchieve',
  components: {
    Wrapper,
    CheckTab,
    DatePicker,
  },
  data() {
    return {
      // 列表序号样式
      rank: {
        rank1,
        rank2,
        rank3,
      },
      // pick date
      date: '',
      timeDuration: '',
      // tab
      actTab: 'income',
      tabs: Object.values(Tabs),
      // table
      ranklist: [],
    };
  },

  created() {
    echarts.registerTheme('roma', roma);
    this._fetchAchievementData();
  },

  mounted() {
    this.initEchart();
    window.addEventListener('resize', this.onChartResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onChartResize);
  },

  methods: {
    // table 序号样式
    makeTableRankStyles(i) {
      if (i < 3) {
        let res = {
          color: '#fff',
          background: '',
          width: '26px',
          height: '26px',
          marginLeft: '-4px',
        };
        const t = this.rank[`rank${i + 1}`];
        res.background = `url(${t}) no-repeat center center / 72%`;
        return res;
      }
      return {};
    },

    // 设置列样式
    setTableCellClass({ columnIndex }) {
      if (columnIndex === 2) {
        return 'table-cell-prod';
      }
    },

    // 选择日期
    pickDate({ duration = [] } = {}) {
      this.timeDuration = duration;
      this.date = duration[0] + ',' + duration[duration.length - 1];
      this._fetchAchievementData();
    },

    // 获取数据
    async _fetchAchievementData() {
      if (!this.date) return;
      try {
        const res = await req.send(req.Apis.sales.report.dataAchievement, {
          date: this.date,
        });
        this.ranklist = [...(res.data.extend || [])];
        const chart = (res.data || {}).chart || {};

        this.tabs.forEach((i) => {
          Tabs[i.id].data = this.matchSeriesData(i.id, chart);
        });
        this.onExTab(this.actTab);
      } catch (err) {
        this.$message.error(`获取数据失败：${err.message || '未知错误'}`);
      }
    },

    // 匹配chart数据
    matchSeriesData(type = 'num', ori = {}) {
      return this.timeDuration.map((i) => {
        return ori[i] ? ori[i][type] : null;
      });
    },

    // 初始化chart
    initEchart() {
      this.myCharts = echarts.dispose(this.$refs['chartblock'], 'roma');
      this.myCharts = echarts.init(this.$refs['chartblock'], 'roma');
    },

    // 监听tab
    onExTab(id) {
      const tab = Tabs[id];
      const chartOpt = { ...tab.tp };
      this.initEchart();
      chartOpt.title.text = tab.t;
      chartOpt.xAxis = {
        type: 'category',
        data: this.timeDuration,
      };

      chartOpt.yAxis.axisLabel = {
        formatter: tab.xAxisf,
      };
      chartOpt.series = [
        {
          name: tab.text,
          data: tab.data,
          type: tab.type,
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(102,192,255,0.75)',
                },
                {
                  offset: 1,
                  color: 'rgba(102,192,255,0)',
                },
              ]),
            },
          },
        },
      ];
      chartOpt.dataZoom = [
        {
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          start: 1,
          end: 100,
        },
      ];

      if (id === Tabs.income.id || id === Tabs.arpu.id) {
        chartOpt.tooltip = {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#595959',
            },
          },
          formatter: function(p) {
            let o = p[0] || {};
            return `${o.seriesName}</br>
                        <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                          o.color
                        };"></span>
                        ${o.name}: ¥${accounting.formatNumber(o.value, 2)}`;
          },
          position: function(pt) {
            return [pt[0], '10%'];
          },
        };
      }

      if (id === Tabs.income.id) {
        chartOpt.title.text += `：¥${accounting.formatNumber(
          this.calTotal(tab.data),
          2,
        )}`;
      }

      if (id === Tabs.actCustomer.id) {
        chartOpt.yAxis.minInterval = 1;
        chartOpt.series[0].barWidth = '50%';
        chartOpt.title.text += `：${this.calTotal(tab.data)}个`;
      }

      this.myCharts.setOption(chartOpt);
    },

    // 计算和
    calTotal(data = []) {
      return data.reduce((r, v) => r + (v || 0), 0);
    },

    // 监听页面布局更新
    onChartResize() {
      this.myCharts && this.myCharts.resize();
    },

    // 跳转广告主详情
    toDetail(id) {
      if (!id) return;
      let url = '/advertiser-manage/detail';
      url += `?id=${id}`;
      $util.openUrl(url, { newWin: true });
    },
  },
};
</script>

<style lang="less" scoped>
.section-report {
  .table {
    padding-top: 48px;
    overflow: hidden;

    /deep/ .el-table th {
      padding: 12px 0;
    }

    /deep/ .el-table td {
      padding: 12px 0;

      &.table-cell-prod {
        color: #2f9eff;
      }
    }

    /deep/ .table-header {
      background: #fafafa;
      border-radius: 4px 4px 0px 0px;

      th {
        background: transparent;
        color: #303133;
        font-size: 14px;
        font-weight: 500;
      }
    }

    .table-index {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #f0f2f5;
      margin-right: 24px;
      font-size: 12px;
      font-family: HelveticaNeue-Medium;
      font-weight: 500;
      color: rgba(96, 98, 102, 1);
    }
  }
}
</style>
